import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import submit from './submit';
import validate from './validate';

// Style
import cx from 'classnames';
import {
  Button,
  Row,
  FormGroup,
  Col,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './StaticBlockForm.css';
import cs from '../../../components/commonStyle.css';
import BlockUploader from './BlockUploader';
import Uploader from './Uploader';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import MultiLanguageInput from '../MultiLanguageInput/MultiLanguageInput';

class StaticBlockForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleFieldChange(fieldName, value) {
    const { dispatch } = this.props;
    dispatch(change('StaticBlockForm', fieldName, value));
  }

  render() {

    const { error, handleSubmit, submitting, dispatch, initialValues, title, formValues } = this.props;
    const { formatMessage } = this.props.intl;

    // Hidden fields to register multilingual fields with Redux Form
    const multilingualFields = [
      'carTripTitle1', 'carTripTitle2', 'carTripContent2', 'carTripTitle3', 'carTripContent3'
    ];
    const langSuffixes = ['_en', '_fr', '_it', '_pt'];
    const hiddenFields = [];
    multilingualFields.forEach(base => {
      langSuffixes.forEach(suffix => {
        hiddenFields.push(
          <Field key={`${base}${suffix}`} name={`${base}${suffix}`} component="input" type="hidden" />
        );
      });
    });

    return (
      <div className={cx(s.pagecontentWrapper)}>
        <div>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <h1 className={s.headerTitle}><FormattedMessage {...messages.staticInfoBlock} /></h1>
              <form onSubmit={handleSubmit((values) => {
                // Merge redux-form values with formValues to ensure all multilingual fields are sent
                const payload = { ...values, ...formValues };
                console.log('🚀 [StaticBlockForm] Sending:', payload);
                return submit(payload, dispatch);
              })}>
                {/* Toggle to enable/disable this block on homepage */}
                <div className={s.toggleContainer}>
                  <label className={s.toggleLabel}>
                    <FormattedMessage {...messages.showOnHomepage} />
                  </label>
                  <label className={s.toggleSwitch}>
                    <Field
                      name="isEnabled"
                      component="input"
                      type="checkbox"
                      className={s.toggleInput}
                    />
                    <span className={s.toggleSlider}></span>
                  </label>
                  <span className={s.toggleStatus}>
                    {formValues?.isEnabled ? 'Activo' : 'Inactivo'}
                  </span>
                </div>

                {/* Hidden fields to register multilingual fields */}
                {hiddenFields}
                {error && <strong>{formatMessage(error)}</strong>}
                <label className={cs.labelTextNew} ><FormattedMessage {...messages.adminTitleLabel} /></label>
                <MultiLanguageInput
                  baseField="carTripTitle1"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <h3 className={cx(cs.commonContentText, cs.spaceBottom3, cs.spaceTop3)}><FormattedMessage {...messages.footerImageBlock} /> #1</h3>
                    <div className={cx(s.siteContainer)}>
                      <label className={cs.labelTextNew} ><FormattedMessage {...messages.imageLabel} /></label>
                      <BlockUploader />
                    </div>
                    <label className={cx(cs.labelTextNew, cs.spaceTop3)} ><FormattedMessage {...messages.adminTitleLabel} /></label>
                    <MultiLanguageInput
                      baseField="carTripTitle2"
                      inputType="text"
                      values={formValues}
                      onChange={this.handleFieldChange}
                    />
                    <label className={cx(cs.labelTextNew, cs.spaceTop3)} ><FormattedMessage {...messages.contentLabel} /></label>
                    <MultiLanguageInput
                      baseField="carTripContent2"
                      inputType="textarea"
                      values={formValues}
                      onChange={this.handleFieldChange}
                    />
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <h3 className={cx(cs.commonContentText, cs.spaceBottom3, cs.spaceTop3)}><FormattedMessage {...messages.footerImageBlock} /> #2</h3>
                    <div className={cx(s.siteContainer)}>
                      <label className={cs.labelTextNew} ><FormattedMessage {...messages.imageLabel} /></label>
                      <Uploader />
                    </div>
                    <label className={cx(cs.labelTextNew, cs.spaceTop3)} ><FormattedMessage {...messages.adminTitleLabel} /></label>
                    <MultiLanguageInput
                      baseField="carTripTitle3"
                      inputType="text"
                      values={formValues}
                      onChange={this.handleFieldChange}
                    />
                    <label className={cx(cs.labelTextNew, cs.spaceTop3)} ><FormattedMessage {...messages.contentLabel} /></label>
                    <MultiLanguageInput
                      baseField="carTripContent3"
                      inputType="textarea"
                      values={formValues}
                      onChange={this.handleFieldChange}
                    />
                  </Col>
                </Row>
                <FormGroup>
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12} className={cx(cs.textAlignRight, 'textAlignLeftRTL', cs.spaceTop3)}>
                      <Button className={cx(cs.btnPrimary, cs.btnlarge)} type="submit" disabled={submitting}>
                        <FormattedMessage {...messages.save} />
                      </Button>
                    </Col>
                  </Row>
                </FormGroup>
              </form>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

}

StaticBlockForm = reduxForm({
  form: 'StaticBlockForm', // a unique name for this form
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(StaticBlockForm);

const selector = formValueSelector('StaticBlockForm');

const mapState = (state) => ({
  formValues: {
    carTripTitle1: selector(state, 'carTripTitle1'),
    carTripTitle1_en: selector(state, 'carTripTitle1_en'),
    carTripTitle1_fr: selector(state, 'carTripTitle1_fr'),
    carTripTitle1_it: selector(state, 'carTripTitle1_it'),
    carTripTitle1_pt: selector(state, 'carTripTitle1_pt'),
    carTripTitle2: selector(state, 'carTripTitle2'),
    carTripTitle2_en: selector(state, 'carTripTitle2_en'),
    carTripTitle2_fr: selector(state, 'carTripTitle2_fr'),
    carTripTitle2_it: selector(state, 'carTripTitle2_it'),
    carTripTitle2_pt: selector(state, 'carTripTitle2_pt'),
    carTripContent2: selector(state, 'carTripContent2'),
    carTripContent2_en: selector(state, 'carTripContent2_en'),
    carTripContent2_fr: selector(state, 'carTripContent2_fr'),
    carTripContent2_it: selector(state, 'carTripContent2_it'),
    carTripContent2_pt: selector(state, 'carTripContent2_pt'),
    carTripTitle3: selector(state, 'carTripTitle3'),
    carTripTitle3_en: selector(state, 'carTripTitle3_en'),
    carTripTitle3_fr: selector(state, 'carTripTitle3_fr'),
    carTripTitle3_it: selector(state, 'carTripTitle3_it'),
    carTripTitle3_pt: selector(state, 'carTripTitle3_pt'),
    carTripContent3: selector(state, 'carTripContent3'),
    carTripContent3_en: selector(state, 'carTripContent3_en'),
    carTripContent3_fr: selector(state, 'carTripContent3_fr'),
    carTripContent3_it: selector(state, 'carTripContent3_it'),
    carTripContent3_pt: selector(state, 'carTripContent3_pt'),
    isEnabled: selector(state, 'isEnabled'),
  }
});

export default injectIntl(withStyles(s, cs)(connect(mapState)(StaticBlockForm)));